@if (action !== 'register'){
    <div class="flex justify-between">
        <h1 class="text-3xl ps-4 first-letter:capitalize">
            {{ ("DASHBOARD.USER_HANDLING."+actionKey()) | translate }}
        </h1>
    </div>
}
<div class=""
     [ngClass]="{
        'grid place-content-center gap-2 lg:grid-cols-2 p-4': action !== 'register'
     }">
    <form [formGroup]="userHandlingForm" (submit)="onSubmit()" class="w-full space-y-6" [ngClass]="{'sm:w-full sm:max-w-sm': action==='register' }">
        <div class="space-y-2">

            <div [ngClass]="{'space-x-2': action !== 'register'}">
                <label>{{ "GLOBAL.EMAIL" | translate }} *</label>
                <app-input  [formController]="userHandlingForm.controls.email" [initialValue]="userHandlingForm.controls.email.value" [placeholder]=" 'GLOBAL.REGISTER_EMAIL_PLACEHOLDER' | translate "
                            [ngClass]="{'block w-full rounded-md overflow-hidden text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-secondary-600 sm:text-sm/6': action==='register' } "/>

                @if(userHandlingForm.controls.email?.errors?.['emailExists']) {
                    <span class="text-secondary-300">
                        {{ "GLOBAL.EMAIL_NOT_VALID" | translate }}
                    </span>
                }

                @if (submitTried() && userHandlingForm.controls.email?.errors?.['required']) {
                    <span class="text-secondary-300">
                        {{ "GLOBAL.REQUIRED_VALUE" | translate }}
                    </span>
                }

            </div>

            @if (action !== 'edit'){

                <div [ngClass]="{'space-x-2': action !== 'register'}">

                    <label>{{ "GLOBAL.PASSWORD" | translate }} *</label>

                    <app-input class="block " type="password" [formController]="userHandlingForm.controls.password" [placeholder]=" 'GLOBAL.REGISTER_PASSWORD_PLACEHOLDER' | translate "
                               [ngClass]="{'block w-full rounded-md overflow-hidden text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-secondary-600 sm:text-sm/6': action==='register' } "/>

                    @if(submitTried() && userHandlingForm.controls.password?.errors?.['required']) {
                        <span class="text-secondary-300">
                        {{ "GLOBAL.REQUIRED_VALUE" | translate }}
                    </span>
                    }

                    @if(submitTried() && userHandlingForm.controls.password?.errors?.['pattern']) {
                        <span class="text-secondary-300">
                        {{ "GLOBAL.PASSWORD_NOT_COMPLEX_ENOUGH" | translate }}
                    </span>
                    }

                </div>

                <div [ngClass]="{'space-x-2': action !== 'register'}">

                    <label [ngClass]="{'block text-sm/6 font-medium text-white-900': action !== 'register'}" >{{ "GLOBAL.CONFIRM_PASSWORD" | translate }} *</label>

                    <app-input class="block " type="password" [formController]="userHandlingForm.controls.passwordConfirmation" [placeholder]=" 'GLOBAL.REGISTER_PASSWORD_CONFIRM_PLACEHOLDER' | translate "
                               [ngClass]="{'block w-full rounded-md overflow-hidden text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-secondary-600 sm:text-sm/6': action==='register' } "/>

                    @if(submitTried() && userHandlingForm.controls.passwordConfirmation?.errors?.['required']) {
                        <span class="text-secondary-300">
                        {{ "GLOBAL.REQUIRED_VALUE" | translate }}
                    </span>
                    }

                    @if(submitTried() && userHandlingForm.controls.passwordConfirmation?.errors?.['isCloneValue']) {
                        <span class="text-secondary-300">
                        {{ "GLOBAL.PASSWORD_MISMATCH" | translate }}
                    </span>
                    }
                </div>
            }


            <div [ngClass]="{'space-x-2': action !== 'register'}">
                <label>{{ "GLOBAL.PHONE_NUMBER" | translate }}</label>
                <app-input class="block " type="tel" [formController]="userHandlingForm.controls.phoneNumber" [initialValue]="userHandlingForm.controls.phoneNumber.value" [placeholder]=" 'GLOBAL.REGISTER_PHONE_NUMBER_PLACEHOLDER' | translate "
                           [ngClass]="{'block w-full rounded-md overflow-hidden text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-secondary-600 sm:text-sm/6': action==='register' } "/>
            </div>
            @if (hasAdminAuth()){
                <div class="w-fit space-x-2 mx-auto">
                    <label>roolit:</label>
                    @for (role of roles(); track role.name) {
                        <div class="flex gap-2 justify-between">
                            <label>{{role.name}}</label>
                            <app-checkbox class="" [margin]="0" (change)="checkRole(role.name, $event)" [value]="userHandlingForm.controls.roles.value.includes(role.name)" />
                        </div>
                    }
                </div>
            }


        </div>

        <div>
            @if ( action !== 'register' ) {
                <label for="company-selector">{{ 'GLOBAL.COMPANY.COMPANY' | translate }}</label>
                <app-select id="company-selector" #companySelect [options]="companyOptionsFiltered()" (selectedOptionOutput)="onCompanySelect($event)" [initialValue]="initialCompanySelection"/>
            } @else {
                <button type="button" class="flex items-center gap-2 cursor-pointer w-full" (click)="toggleCompanySelect()">
                    <app-checkbox #check id="company-check" color="secondary" [value]="checkBox()" />
                    <label for="company-check">{{ 'GLOBAL.COMPANY.COMPANY' | translate }}</label>
                </button>
            }

            @if(newCompany()){
                <div class="grid grid-cols-2 gap-2">

                    <div class="space-x-2 col-span-2" [ngClass]="{'space-x-0': action === 'register'}">
                        <label>{{ "GLOBAL.COMPANY.NAME" | translate }} *</label>
                        <app-input class="block " [formController]="newCompany().controls.name" [initialValue]="newCompany().controls.name.value" [placeholder]="'GLOBAL.REGISTER_COMPANY_NAME_PLACEHOLDER' | translate "
                                   [ngClass]="{'block w-full rounded-md overflow-hidden text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-secondary-600 sm:text-sm/6': action==='register' } "/>
                        @if(submitTried() && newCompany().controls.name?.errors?.['required']) {
                            <span class="text-secondary-300">
                                {{ "GLOBAL.REQUIRED_VALUE" | translate }}
                            </span>
                        }
                    </div>

                    <div class="space-x-2 col-span-2" [ngClass]="{'space-x-0': action === 'register'}">
                        <label>{{ "GLOBAL.COMPANY.BUSINESS_ID" | translate }} *</label>
                        <app-input class="block " [formController]="newCompany().controls.businessNumber" [initialValue]="newCompany().controls.businessNumber.value" [placeholder]="'GLOBAL.REGISTER_COMPANY_BUSINESS_ID_PLACEHOLDER' | translate "
                                   [ngClass]="{'block w-full rounded-md overflow-hidden text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-secondary-600 sm:text-sm/6': action==='register' } "/>
                        @if(submitTried() && newCompany().controls.businessNumber?.errors?.['required']) {
                            <span class="text-secondary-300">
                                {{ "GLOBAL.REQUIRED_VALUE" | translate }}
                            </span>
                        }
                    </div>
                    @if (action !== 'register'){
                        <div class="space-x-2" [ngClass]="{'space-x-0 col-span-2': action === 'register'}">
                            <label>{{ "GLOBAL.COUNTRY" | translate }}</label>
                            <app-input class="block " [formController]="newCompany().controls.country" [initialValue]="newCompany().controls.country.value" [placeholder]="inputPlaceHolder()"
                                       [ngClass]="{'block w-full rounded-md overflow-hidden text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-secondary-600 sm:text-sm/6': action==='register' } "/>
                        </div>

                        <div class="space-x-2" [ngClass]="{'space-x-0 col-span-2': action === 'register'}">
                            <label>{{ "GLOBAL.REGION" | translate }}</label>
                            <app-input class="block " [formController]="newCompany().controls.region" [initialValue]="newCompany().controls.region.value" [placeholder]="inputPlaceHolder()"
                                       [ngClass]="{'block w-full rounded-md overflow-hidden text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-secondary-600 sm:text-sm/6': action==='register' } "/>
                        </div>

                        <div class="space-x-2" [ngClass]="{'space-x-0 col-span-2': action === 'register'}">
                            <label>{{ "GLOBAL.CITY" | translate }}</label>
                            <app-input class="block " [formController]="newCompany().controls.city" [initialValue]="newCompany().controls.city.value" [placeholder]="inputPlaceHolder()"
                                       [ngClass]="{'block w-full rounded-md overflow-hidden text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-secondary-600 sm:text-sm/6': action==='register' } "/>
                        </div>

                        <div class="space-x-2" [ngClass]="{'space-x-0 col-span-2': action === 'register'}">
                            <label>{{ "GLOBAL.POSTAL_CODE" | translate }}</label>
                            <app-input class="block " [formController]="newCompany().controls.postalCode" [initialValue]="newCompany().controls.postalCode.value" [placeholder]="inputPlaceHolder()"
                                       [ngClass]="{'block w-full rounded-md overflow-hidden text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-secondary-600 sm:text-sm/6': action==='register' } "/>
                        </div>

                        <div class="space-x-2" [ngClass]="{'space-x-0 col-span-2': action === 'register'}">
                            <label>{{ "GLOBAL.ADDRESS" | translate }}</label>
                            <app-input class="block " [formController]="newCompany().controls.addressFirst" [initialValue]="newCompany().controls.addressFirst.value" [placeholder]="inputPlaceHolder()"
                                       [ngClass]="{'block w-full rounded-md overflow-hidden text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-secondary-600 sm:text-sm/6': action==='register' } "/>
                        </div>

                        <div class="space-x-2 col-span-2" [ngClass]="{'space-x-0': action === 'register'}">
                            <label>{{ "GLOBAL.ADDRESS_SECONDARY" | translate }}</label>
                            <app-input class="block " [formController]="newCompany().controls.addressSecond" [initialValue]="newCompany().controls.addressSecond.value" [placeholder]="inputPlaceHolder()"
                                       [ngClass]="{'block w-full rounded-md overflow-hidden text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-secondary-600 sm:text-sm/6': action==='register' } "/>
                        </div>
                    }
                </div>
            }
        </div>

        <div>
            <div class="flex items-center gap-2">
                <app-checkbox #check id="terms-check" color="secondary" [formController]="userHandlingForm.controls.approveUserConditions" />
                <label for="terms-check"> {{ "GLOBAL.APPROVE" | translate }} <a href="https://purso.fi/tietosuojaseloste/" target="_blank" class="font-semibold text-secondary-300 hover:underline"> {{ "GLOBAL.TERMS_AND_CONDITIONS" | translate }} </a> </label>
            </div>
        </div>


        <div class="flex justify-center lg:col-span-2">
            <button type="submit" class="bg-secondary text-white p-3 flex gap-2 rounded-md font-bold justify-center"
                    [ngClass]="{ ' flex w-full justify-center rounded-md bg-secondary px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-secondary-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary-600': action === 'register' }">
                @if (action=== 'register') {
                    {{ "GLOBAL.REGISTER" | translate }}
                } @else {
                    {{ "GLOBAL.SAVE" | translate }}
                }
            </button>
        </div>
        @if (action === 'register') {
            <div class="mt-10 flex justify-center">
                <span class="text-center">{{ "GLOBAL.ALREADY_USER" | translate }} <a [routerLink]="['/login']" class="font-semibold text-white hover:text-secondary-300">{{ "GLOBAL.GO_TO_LOGIN" | translate }}</a></span>
            </div>
        }

    </form>
</div>
